import { FileProviderViewState, getFileProviders } from 'owa-fileprovider-store';
import { createAttachmentFromLink } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { trace } from 'owa-trace';

export function getProviderAndAttachLinkAsCopy(linkId: string) {
    const providerId = extractOneDriveProFileProviderId(getFileProviders());
    if (!isNullOrWhiteSpace(providerId)) {
        createAttachmentFromLink(linkId, providerId, false /* isTryAgain */);
    }
}

function extractOneDriveProFileProviderId(providers: FileProviderViewState[]): string {
    for (let i = 0; i < providers.length; i++) {
        if (providers[i].type === AttachmentDataProviderType.OneDrivePro) {
            return providers[i].model.Id;
        }
    }

    trace.warn(
        'createAttachmentFromLink: Could not get OneDrive Pro provider ID. File will not upload.'
    );
    return '';
}
